// import React, { useState } from "react";
// import {
//   Button,
// } from "@mui/material";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import distributorServices from "../../Services/distributorServices";

// const RecordSuppliers = () => {

//   const navigate = useNavigate();

//   const [data, setData] = useState({
//     name: "",
//     company: "",
//     address: "",
//     phone: "",
//     email: ""
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!data.name) {
//       toast.error("Distributor Name is required");
//       return;
//     }
//     if (!data.company) {
//       toast.error("Company Name is required");
//       return;
//     }
//     if (!data.address) {
//       toast.error("Address is required");
//       return;
//     }
//     if (!data.phone) {
//       toast.error("Phone Number is required");
//       return;
//     }
//     if (!data.email) {
//       toast.error("Email is required");
//       return;
//     }
//     try {
//       await distributorServices.create(data);
//       toast.success("Supplier Added Successfully");

//       navigate("/suppliers");
//     } catch (error) {
//       toast.error("Error Adding Supplier");
//     }
//   };

//   return (
//     <>
//       <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//         <h1 className="m-[30px] text-center font-[700] text-[20px]">
//           Record Suppliers
//         </h1>
//         <div className="mt-10">
//          <div>
         
//           <div className="grid grid-cols-2 gap-3"> 
//           <input type="text" name="name" value={data.name} onChange={handleChange} className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none w-full focus:border-primary mt-1" placeholder="Distributer Name"/>
//           <input type="text" name="company" value={data.company} onChange={handleChange} className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1" placeholder="Company Name" />
//           </div>
//           <div className="grid grid-cols-3 gap-3 mt-3"> 
//           <input type="text" name="address" value={data.address} onChange={handleChange} className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none w-full focus:border-primary mt-1" placeholder="Address" />
//           <input type="phone" name="phone" value={data.phone} onChange={handleChange} className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1" placeholder="Phone No."/>
//           <input type="email" name="email" value={data.email} onChange={handleChange} className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1" placeholder="Email"/>
//           </div>
//          </div>
//           <div className="text-center my-[30px]">
//             <Button
//               type="submit"
//               variant="contained"
//               sx={{
//                 backgroundColor: "#00A95B",
//                 "&:hover": { backgroundColor: "#00A95B" },
//               }}
//             >
//               Add Supplier
//             </Button>
//           </div>
//         </div>
//       </form>
      
//     </>
//   );
// };

// export default RecordSuppliers;

import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import distributorServices from "../../Services/distributorServices";
import {
  MdPeople,
  MdBusiness,
  MdLocationOn,
  MdPhone,
  MdEmail,
  MdCheck,
  MdArrowBack,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const FIELDS = [
  {
    name: "name",
    label: "Distributor Name",
    placeholder: "e.g. Ali Medical Supplies",
    type: "text",
    icon: MdPeople,
  },
  {
    name: "company",
    label: "Company Name",
    placeholder: "e.g. Ali Pharma Ltd.",
    type: "text",
    icon: MdBusiness,
  },
  {
    name: "address",
    label: "Address",
    placeholder: "e.g. 12 Main Blvd, Lahore",
    type: "text",
    icon: MdLocationOn,
  },
  {
    name: "phone",
    label: "Phone No.",
    placeholder: "e.g. 0300-1234567",
    type: "tel",
    icon: MdPhone,
  },
  {
    name: "email",
    label: "Email",
    placeholder: "e.g. supplier@example.com",
    type: "email",
    icon: MdEmail,
  },
];

const RecordSuppliers = () => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    name: "",
    company: "",
    address: "",
    phone: "",
    email: "",
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const field of FIELDS) {
      if (!data[field.name]) {
        toast.error(`${field.label} is required`);
        return;
      }
    }

    if (data.phone.length !== 11) {
      toast.error("Phone number must be exactly 11 digits");
      return;
    }

    try {
      setSaving(true);
      await distributorServices.create(data);
      toast.success("Supplier Added Successfully");
      navigate("/suppliers");
    } catch (error) {
      toast.error("Error Adding Supplier");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-[#f4f7fb] py-10 px-4"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      <div className="max-w-[1400px] mx-auto">

        {/* ── Card ── */}
        <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] overflow-hidden">

          {/* ── Header ── */}
          <div className="flex items-center justify-between px-6 py-5 bg-[#00A95B]">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-xl bg-white bg-opacity-20 flex items-center justify-center">
                <MdPeople size={17} className="text-white" />
              </div>
              <div>
                <h2 className="text-white text-lg font-bold leading-tight">
                  Add New Supplier
                </h2>
                <p className="text-green-100 text-[11px] mt-0.5">
                  Fill in all required fields to add a supplier
                </p>
              </div>
            </div>
            {/* <button
              type="button"
              onClick={() => navigate("/suppliers")}
              className="w-8 h-8 rounded-xl bg-white bg-opacity-20 flex items-center justify-center text-white hover:bg-opacity-30 transition-colors"
            >
              <MdArrowBack size={17} />
            </button> */}
          </div>

          {/* ── Body ── */}
          <form onSubmit={handleSubmit}>
            <div className="px-6 py-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {FIELDS.map(({ name, label, placeholder, type, icon: Icon }) => (
                  <div key={name} className={name === "address" ? "sm:col-span-2" : ""}>
                    <label className="block text-[11px] font-semibold tracking-wider uppercase text-gray-500 mb-1.5">
                      {label} <span className="text-red-400">*</span>
                    </label>
                    <div className="relative flex items-center">
                      <Icon
                        size={15}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
                      />
                      <input
                        type={type}
                        name={name}
                        value={data[name]}
                        placeholder={placeholder}
                        onChange={(e) => {
                          if (name === "phone") {
                            const val = e.target.value.replace(/\D/g, "").slice(0, 11);
                            setData((prev) => ({ ...prev, phone: val }));
                          } else {
                            handleChange(e);
                          }
                        }}
                        maxLength={name === "phone" ? 11 : undefined}
                        className="w-full bg-gray-50 border border-gray-200 rounded-xl pl-9 pr-3 py-2.5 text-sm text-gray-800 placeholder-gray-300 outline-none focus:border-[#00A95B] focus:ring-2 focus:ring-[#00A95B] focus:ring-opacity-20 transition-all"
                      />
                      {name === "phone" && (
                        <span className={`absolute right-3 text-[10px] font-medium pointer-events-none ${data.phone.length === 11 ? "text-[#00A95B]" : "text-gray-300"}`}>
                          {data.phone.length}/11
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Footer ── */}
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
              <p className="text-[11px] text-gray-400">
                <span className="text-red-400 font-bold">*</span> Required fields
              </p>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => navigate("/suppliers")}
                  className="px-5 py-2.5 rounded-xl text-sm font-semibold text-gray-500 bg-white border border-gray-200 hover:bg-gray-100 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#00A95B] hover:bg-opacity-90 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {saving ? (
                    <>
                      <AiOutlineLoading3Quarters size={14} className="animate-spin" />
                      Saving…
                    </>
                  ) : (
                    <>
                      <MdCheck size={15} />
                      Add Supplier
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default RecordSuppliers;